module.exports = __webpack_public_path__ + "img/4.473badc0.png";